import { F_MapMarkerIndoorStandFragment } from '__generated__v2/graphql';
import { useCtxMapView } from 'pages/special/OsloDesignFair/map/CtxMapView';
import {
    GlobalLayerIds,
    GlobalSourceIds
} from 'pages/special/OsloDesignFair/map/mapContent/Markers/constants';
import { getFeature_IndoorStandSymbol } from 'pages/special/OsloDesignFair/map/mapContent/Markers/IndoorStandMarkers/getFeatures';
import { Layer, Source } from 'react-map-gl';

interface Props {
    markers: F_MapMarkerIndoorStandFragment[];
}

export const IndoorStandMarkersSymbol = (props: Props) => {
    const ctxMapView = useCtxMapView();

    const features = props.markers
        .filter((e) => e.hasInteractivity)
        .filter((e) => e.selectable)
        .map<GeoJSON.Feature>((e) =>
            getFeature_IndoorStandSymbol(
                e,
                ctxMapView.highlightedMarkerIds,
                ctxMapView.forceHighlightSelectableMarkers,
                1
            )
        );

    return (
        <Source
            id={GlobalSourceIds.IndoorStandSymbols}
            type="geojson"
            data={{
                type: 'FeatureCollection',
                features
            }}
            cluster={false}
        >
            <Layer
                id={GlobalLayerIds.IndoorStandCircles}
                type="circle"
                source={GlobalSourceIds.IndoorStandSymbols}
                paint={{
                    'circle-radius': 4,
                    'circle-color': ['get', 'circleColor'],
                    'circle-stroke-width': 2,
                    'circle-stroke-color': '#ffffff',
                    'circle-opacity': 1,
                    'circle-stroke-opacity': 1
                }}
            />
            <Layer
                id={GlobalLayerIds.IndoorStandSymbols}
                type="symbol"
                source={GlobalSourceIds.IndoorStandSymbols}
                layout={{
                    'text-field': ['get', 'text'],
                    'text-font': ['Inter Medium'],
                    'text-size': 13,
                    'text-anchor': 'top',
                    'text-offset': ['step', ['zoom'], [0, 0.8], 19, [0, 0.8]],
                    'icon-size': ['step', ['zoom'], 0, 19, 0.4],
                    'icon-anchor': 'center',
                    'icon-offset': [0, -22],
                    'icon-image': ['get', 'logoUrl']
                }}
                paint={{
                    'text-color': ['get', 'labelColor'],
                    'text-halo-color': ['get', 'haloColor'],
                    'text-halo-width': 2,
                    'icon-opacity': 1,
                    'text-opacity': 1
                }}
            />
        </Source>
    );
};
